
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"height":"24","width":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"y":"5","width":"24","height":"2.5","rx":"2"}}),_c('rect',{attrs:{"x":"5","y":"11","width":"14","height":"2.5","rx":"2"}}),_c('rect',{attrs:{"x":"10","y":"17","width":"4","height":"2.5","rx":"2"}})])
          )
        }
      }
    